export default "__VITE_ASSET__BhvwW9zS__"